export default __webpack_public_path__ + "static/media/menu.2b2c5ff6.svg";